export default __webpack_public_path__ + "static/media/landing-page-1.ecf49a7f.jpg";